import React from 'react';
import { Helmet } from 'react-helmet';
import ServicePage from '../components/ServicePage';
import html from '../content/rapidAiAutomationSprint.html.js';
import { useLocation } from 'react-router-dom';
import { getCanonicalUrl } from '../utils/canonicalUrl';

export default function RapidAIAutomationSprint() {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Rapid AI Automation Sprint',
    description:
      'A focused 5-business-day sprint that turns one high-friction workflow into a working AI-assisted prototype.',
    url: canonicalUrl,
  };
  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>Rapid AI Automation Sprint</title>
        <meta name="description" content="A focused AI automation sprint for turning one manual workflow into a working prototype in days." />
        <meta property="og:title" content="Rapid AI Automation Sprint" />
        <meta property="og:description" content="Turn one high-friction workflow into a working AI-assisted prototype with clear controls and ROI." />
        <meta property="og:image" content="/assets/visuals/re-code_image.jpg" />
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <ServicePage
        title="Rapid AI Automation Sprint"
        tagline="Turning one high-friction workflow into a working AI-assisted prototype in days, not months."
        ctaText="Book a Sprint Call"
        ctaLink="/contact"
        htmlContent={html}
        imageSrc="/assets/visuals/re-code_image.jpg"
        imageAlt="Rapid AI automation sprint visual"
      />
    </>
  );
}
